import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { getStorage } from 'src/app/core/utilities';
@Component({
    selector: 'app-tisco-consent',
    templateUrl: './tisco-consent.component.html',
    styleUrls: ['./tisco-consent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoConsentComponent implements OnInit {
  @Input() data: any = { url: null, safeUrl: null };
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }
  timer$: Subscription
  ngOnInit() {
    //console.log('TiscoConsentComponent')
    this.timer$ = Observable.interval(3000).take(100).subscribe(x => {
      let ref = getStorage('check_reference_id' + this.data['reference_id']);
      //console.log('iframe', x, this.data['reference_id'], ref);
      if (ref) {
        this.change.emit({
          ...this.data,
          url: null,
          safeUrl: null
        });
      }

    });
  }
  ngOnDestroy() {
    this.timer$.unsubscribe();
  }
}
